import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { SkeletonAdminScreen } from 'structure/admin/loading-screen';
import { settingsModuleQuery } from 'system/structure-modules';

export function SuspenseFallback() {
    return <SkeletonAdminScreen />;
}

export default function SettingsLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]/settings/one'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'settings',
        instanceKey: 'one',
        moduleQuery: settingsModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig} loadingScreen={<SkeletonAdminScreen />}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
